export function mapWithIndexFilterIsSelected<T extends { isSelected: boolean }>(source: T[]): (T & { index: number })[] {
	return source.map((t, index) => ({ index, ...t })).filter(t => t.isSelected);
}
